import { useEffect } from 'react';
import { SITE_ORIGIN } from '../data/site';

// Sets the tags Google needs on a client-rendered route, then puts the
// document head back so other pages are not left with this page's canonical.
function setMeta(attr, key, content) {
  const selector = `meta[${attr}="${key}"]`;
  let el = document.head.querySelector(selector);
  const created = !el;
  const previous = el ? el.getAttribute('content') : null;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
  return () => {
    if (created) el.remove();
    else if (previous == null) el.removeAttribute('content');
    else el.setAttribute('content', previous);
  };
}

const Seo = ({ title, description, path, jsonLd }) => {
  const json = typeof jsonLd === 'string' ? jsonLd : JSON.stringify(jsonLd);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const url = `${SITE_ORIGIN}${path}`;

    const restore = [
      setMeta('name', 'description', description),
      setMeta('property', 'og:title', title),
      setMeta('property', 'og:description', description),
      setMeta('property', 'og:type', 'website'),
      setMeta('property', 'og:url', url),
      setMeta('property', 'og:site_name', 'The WasteGame'),
    ];

    let canonical = document.head.querySelector('link[rel="canonical"]');
    const createdCanonical = !canonical;
    const previousHref = canonical ? canonical.getAttribute('href') : null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-page-seo', 'true');
    script.text = json;
    document.head.appendChild(script);

    return () => {
      document.title = previousTitle;
      restore.forEach((undo) => undo());
      if (createdCanonical) canonical.remove();
      else if (previousHref) canonical.setAttribute('href', previousHref);
      script.remove();
    };
  }, [title, description, path, json]);

  return null;
};

export default Seo;
